import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portal-settings',
  templateUrl: './portal-settings.component.html',
  styleUrls: ['./portal-settings.component.css']
})
export class PortalSettingsComponent implements OnInit {
  portalSettingsItems: any[] = [
    {
      title: 'Domains',
      description: 'Manage your domains',
      icon: 'fa fa-paint-brush',
      routerLink: 'branding'
    },
    {
      title: 'Navigation',
      description: 'Manage your navigation',
      icon: 'fa fa-user',
      routerLink: 'identity'
    },
    {
      title: 'Payments',
      description: 'Manage your payments',
      icon: 'fa fa-eye',
      routerLink: 'overview'
    },
    {
      title: 'Mailing',
      description: 'Manage your mailing',
      icon: 'fa fa-pen',
      routerLink: 'content'
    }
  ]
  constructor() { }

  ngOnInit() {
  }

}
